import { useState } from 'react'
import ReactDOM from "react-dom";

import OutsideClickComponent from '../../../../fragments/OutsideClickComponent'
import Card from '../../../../common/Card'
import Button from '../../../../common/Button'
import Backdrop from '../../../../common/modal/Backdrop';
import Modal from '../../../../common/Modal';
import ModalInnerWrapper from '../../../../common/ModalInnerWrapper';
import CreateLawFirmNegotiatorForm from '../../forms/CreateLawFirmNegotiatorForm';

import classes from './NegotiatorsControls.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { caseActions } from '../../../../../store/case';
import { caseQuickUpdate } from '../../../../../lib/fetchApi';
import { notificationActions } from '../../../../../store/notifications';

export default function NegotiatorsControls({primaryAttorney, thereIsANegotiator}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const [controlsOpened, setControlsopened] = useState(false)
    const [modalOpned, setModalOpened] = useState(false)
    const [modalCreateOpned, setModalCreateOpened] = useState(false)
    const [componentData, setComponentData] = useState(primaryAttorney)

    const showModal = () => {
        setControlsopened(prevState => prevState = !prevState)
    }

    const deleteitem = async () => {
        let reqBody = {
            type: `case_attorney`,
            type_id: primaryAttorney.id,
            fields: {
                negotiator_id: null,
                negotiator_type: null,
                negotiator: null,
            }
        } 

        let dispatchBody = {
            folder: 'attorneys',
            item: {
                itemId: primaryAttorney.id,
                fields: [
                    {
                        field: 'negotiator_id',
                        value: null
                    },
                    {
                        field: 'negotiator_type',
                        value: null
                    },
                    {
                        field: 'negotiator',
                        value: null
                    }
                ]              
            },
        } 
    

        setTimeout(() => {
            dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
        }, 0)
       
        setControlsopened(false)
        const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } 
        
    }

    const openModalHandler = () => {
        setModalOpened(true)
        setControlsopened(false)
    }

    const closeModalHandler = () => {
        setModalOpened(false)
    }

    const openModalCreateHandler = () => {
        setModalCreateOpened(true)
        setControlsopened(false)
    }

    const closeModalCreateHandler = () => {
        setModalCreateOpened(false)
    }


    return <div className={classes.controls_container}>
        <button onClick={showModal} className={classes.controls_button}>
            <i className="ti ti-dots-vertical"></i>
            <span className="sr-only">open item menu</span>
        </button>


        {controlsOpened && <OutsideClickComponent task={showModal}>
            <div className={classes.controls_window}>
                <Card>
                    <ul>
                        {thereIsANegotiator && <li><Button click={deleteitem} btnStyle={'btn_simple'}><i className='ti ti-trash'></i>Clear Item</Button></li>}
                        {thereIsANegotiator && <li>
                            <Button click={openModalHandler} btnStyle={'btn_simple'}><i className='ti ti-edit'></i>Edit Item</Button>
                        </li>}
                        <li>
                            <Button click={openModalCreateHandler} btnStyle={'btn_simple'}><i className="ti ti-square-plus"></i>Create</Button>
                        </li>
                    </ul>
                </Card>
            </div>    
        </OutsideClickComponent>}

        {modalOpned && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Edit Negotiator'}>
                        <CreateLawFirmNegotiatorForm closeModal={closeModalHandler} firmData={componentData} edit={true} negotiator={thereIsANegotiator}/>
                    </ModalInnerWrapper> 
                    
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}

        {modalCreateOpned && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalCreateHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalCreateHandler} modalTitle={'Create Negotiator'}>
                        <CreateLawFirmNegotiatorForm closeModal={closeModalCreateHandler} firmData={componentData} />
                    </ModalInnerWrapper> 
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </div>
}